import { FlagVariants } from "@kamae-apps/shared/Components/Fondations/Flags/Flags"
import { ReactNode } from "react"
export const flagsDictionary: Record<FlagVariants, ReactNode> = Object.freeze({
  fr: (
    <>
      <g clipPath="url(#clip0_5625_2318)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 0H16V12H11V0Z"
          fill="#F50100"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H5V12H0V0Z"
          fill="#2E42A5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 0H11V12H5V0Z"
          fill="#F7FCFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_5625_2318">
          <rect
            width="16"
            height="12"
            rx="1"
            fill="white"
          />
        </clipPath>
      </defs>
    </>
  ),
  en: (
    <>
      <g clipPath="url(#clip0_5625_2207)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V12H16V0H0Z"
          fill="#2E42A5"
        />
        <mask
          id="mask0_5625_2207"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="12"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V12H16V0H0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_5625_2207)">
          <path
            d="M-1.78156 11.1427L1.73929 12.6317L16.0799 1.6189L17.9371 -0.593837L14.172 -1.09151L8.32284 3.65422L3.61484 6.85174L-1.78156 11.1427Z"
            fill="white"
          />
          <path
            d="M-1.29956 12.1859L0.494147 13.05L17.2702 -0.799421H14.7516L-1.29956 12.1859Z"
            fill="#F50100"
          />
          <path
            d="M17.7816 11.1427L14.2607 12.6317L-0.0798779 1.6189L-1.93704 -0.593837L1.82799 -1.09151L7.67719 3.65422L12.3852 6.85174L17.7816 11.1427Z"
            fill="white"
          />
          <path
            d="M17.6614 11.8914L15.8677 12.7555L8.72433 6.82582L6.60646 6.16331L-2.11576 -0.586292H0.402819L9.12014 6.0031L11.4356 6.79752L17.6614 11.8914Z"
            fill="#F50100"
          />
          <mask
            id="path-8-inside-1_5625_2207"
            fill="white"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.88888 -1H6.11111V4H-0.986237V8H6.11111V13H9.88888V8H17.0138V4H9.88888V-1Z"
            />
          </mask>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.88888 -1H6.11111V4H-0.986237V8H6.11111V13H9.88888V8H17.0138V4H9.88888V-1Z"
            fill="#F50100"
          />
          <path
            d="M6.11111 -1V-2H5.11111V-1H6.11111ZM9.88888 -1H10.8889V-2H9.88888V-1ZM6.11111 4V5H7.11111V4H6.11111ZM-0.986237 4V3H-1.98624V4H-0.986237ZM-0.986237 8H-1.98624V9H-0.986237V8ZM6.11111 8H7.11111V7H6.11111V8ZM6.11111 13H5.11111V14H6.11111V13ZM9.88888 13V14H10.8889V13H9.88888ZM9.88888 8V7H8.88888V8H9.88888ZM17.0138 8V9H18.0138V8H17.0138ZM17.0138 4H18.0138V3H17.0138V4ZM9.88888 4H8.88888V5H9.88888V4ZM6.11111 0H9.88888V-2H6.11111V0ZM7.11111 4V-1H5.11111V4H7.11111ZM-0.986237 5H6.11111V3H-0.986237V5ZM0.0137634 8V4H-1.98624V8H0.0137634ZM6.11111 7H-0.986237V9H6.11111V7ZM7.11111 13V8H5.11111V13H7.11111ZM9.88888 12H6.11111V14H9.88888V12ZM8.88888 8V13H10.8889V8H8.88888ZM17.0138 7H9.88888V9H17.0138V7ZM16.0138 4V8H18.0138V4H16.0138ZM9.88888 5H17.0138V3H9.88888V5ZM8.88888 -1V4H10.8889V-1H8.88888Z"
            fill="white"
            mask="url(#path-8-inside-1_5625_2207)"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_5625_2207">
          <rect
            width="16"
            height="12"
            rx="1"
            fill="white"
          />
        </clipPath>
      </defs>
    </>
  ),
  es: (
    <>
      <g clipPath="url(#clip0_5625_2317)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V12H16V0H0Z"
          fill="#FFB400"
        />
        <mask
          id="mask0_5625_2317"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="12"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V12H16V0H0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_5625_2317)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V3H16V0H0Z"
            fill="#C51918"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 9V12H16V9H0Z"
            fill="#C51918"
          />
          <rect
            x="2.504"
            y="5.13599"
            width="0.56"
            height="2.912"
            fill="#F1F9FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.288 4.63208H2.28V4.91208H2.448V5.13608H3.12V4.91208H3.288V4.63208Z"
            fill="#C88A02"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.12 8.21607H3.288V8.49607H2.28V8.21607H2.448V7.99207H3.12V8.21607Z"
            fill="#C88A02"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.784 4.68802C2.90586 4.68802 2.91825 4.64213 2.99015 4.5736C3.04598 4.52038 3.176 4.45437 3.176 4.38002C3.176 4.20992 3.00049 4.07202 2.784 4.07202C2.5675 4.07202 2.392 4.20992 2.392 4.38002C2.392 4.46286 2.48154 4.51824 2.54924 4.5736C2.62057 4.63192 2.67293 4.68802 2.784 4.68802Z"
            fill="#AD1619"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.28 8.49597H3.288V8.94397C3.288 8.94397 3.162 8.88797 3.036 8.88797C2.91 8.88797 2.784 8.94397 2.784 8.94397C2.784 8.94397 2.658 8.88797 2.532 8.88797C2.406 8.88797 2.28 8.94397 2.28 8.94397V8.49597Z"
            fill="#005BBF"
          />
          <mask
            id="mask1_5625_2317"
            maskUnits="userSpaceOnUse"
            x="2"
            y="8"
            width="2"
            height="1"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2.28 8.49597H3.288V8.94397C3.288 8.94397 3.162 8.88797 3.036 8.88797C2.91 8.88797 2.784 8.94397 2.784 8.94397C2.784 8.94397 2.658 8.88797 2.532 8.88797C2.406 8.88797 2.28 8.94397 2.28 8.94397V8.49597Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_5625_2317)" />
          <rect
            x="7.992"
            y="5.13599"
            width="0.56"
            height="2.912"
            fill="#F1F9FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.77601 4.63208H7.76801V4.91208H7.93601V5.13608H8.60801V4.91208H8.77601V4.63208Z"
            fill="#C88A02"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.60801 8.21607H8.77601V8.49607H7.76801V8.21607H7.93601V7.99207H8.60801V8.21607Z"
            fill="#C88A02"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.272 4.68802C8.39387 4.68802 8.40626 4.64213 8.47815 4.5736C8.53398 4.52038 8.664 4.45437 8.664 4.38002C8.664 4.20992 8.4885 4.07202 8.272 4.07202C8.05551 4.07202 7.88 4.20992 7.88 4.38002C7.88 4.46286 7.96954 4.51824 8.03725 4.5736C8.10857 4.63192 8.16093 4.68802 8.272 4.68802Z"
            fill="#AD1619"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.76801 8.49597H8.77601V8.94397C8.77601 8.94397 8.65001 8.88797 8.52401 8.88797C8.39801 8.88797 8.27201 8.94397 8.27201 8.94397C8.27201 8.94397 8.14601 8.88797 8.02001 8.88797C7.89401 8.88797 7.76801 8.94397 7.76801 8.94397V8.49597Z"
            fill="#005BBF"
          />
          <mask
            id="mask2_5625_2317"
            maskUnits="userSpaceOnUse"
            x="7"
            y="8"
            width="2"
            height="1"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.76801 8.49597H8.77601V8.94397C8.77601 8.94397 8.65001 8.88797 8.52401 8.88797C8.39801 8.88797 8.27201 8.94397 8.27201 8.94397C8.27201 8.94397 8.14601 8.88797 8.02001 8.88797C7.89401 8.88797 7.76801 8.94397 7.76801 8.94397V8.49597Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask2_5625_2317)" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.49397 7.83994C2.59493 7.71754 2.65139 7.60618 2.65139 7.48791C2.65139 7.41334 2.6292 7.34893 2.59032 7.29631L2.59689 7.29336C2.59629 7.29363 2.70765 7.24509 2.74642 7.22649C2.8185 7.19194 2.882 7.15533 2.94391 7.11031C2.98343 7.08156 3.03639 7.05025 3.11712 7.0069L3.21347 6.95568C3.25271 6.93474 3.28193 6.9187 3.30907 6.90295C3.39365 6.85389 3.44955 6.81334 3.4923 6.75912C3.59356 6.63072 3.57254 6.45666 3.43064 6.36005C3.36112 6.31272 3.26731 6.28556 3.1298 6.26418L2.93312 6.23369C2.86731 6.22336 2.8086 6.21372 2.75624 6.20457C3.10052 6.14728 3.59214 6.16834 3.80839 6.27999L4.01392 5.88192C3.57325 5.65439 2.56918 5.67763 2.19412 5.93592C1.91902 6.12538 1.95593 6.41176 2.24216 6.53508C2.36176 6.58661 2.51767 6.6208 2.8062 6.66715C2.75785 6.6952 2.71776 6.72083 2.68041 6.74799C2.64253 6.77553 2.60195 6.79893 2.55273 6.82253C2.52919 6.83382 2.45949 6.86442 2.42753 6.87845L2.42751 6.87846L2.42751 6.87847L2.41145 6.88554C2.17831 6.99155 2.06516 7.1382 2.09897 7.40293L2.11727 7.54624L2.1501 7.55632L2.49397 7.83994ZM2.20578 7.4696L2.20507 7.47166L2.20561 7.4702L2.20578 7.4696ZM8.35297 7.48791C8.35297 7.60618 8.40943 7.71754 8.51039 7.83994L8.85425 7.55632L8.88709 7.54624L8.90539 7.40293C8.9392 7.1382 8.82605 6.99155 8.59291 6.88554L8.57685 6.87846C8.5449 6.86444 8.47518 6.83382 8.45163 6.82253C8.40241 6.79893 8.36182 6.77553 8.32395 6.74799C8.2866 6.72083 8.24651 6.6952 8.19816 6.66715C8.48668 6.6208 8.6426 6.58661 8.7622 6.53508C9.04843 6.41176 9.08534 6.12538 8.81024 5.93592C8.43518 5.67763 7.43111 5.65439 6.99044 5.88192L7.19597 6.27999C7.41222 6.16834 7.90384 6.14728 8.24812 6.20457C8.19576 6.21372 8.13705 6.22336 8.07124 6.23369L7.87456 6.26418C7.73705 6.28556 7.64324 6.31272 7.57372 6.36005C7.43182 6.45666 7.4108 6.63072 7.51206 6.75912C7.55481 6.81334 7.6107 6.85389 7.69529 6.90295C7.72243 6.9187 7.75165 6.93474 7.79089 6.95568L7.88724 7.0069C7.96797 7.05025 8.02093 7.08156 8.06045 7.11031C8.12236 7.15533 8.18586 7.19194 8.25794 7.22649C8.29671 7.24509 8.40807 7.29363 8.40747 7.29336L8.41404 7.29631C8.37516 7.34893 8.35297 7.41334 8.35297 7.48791Z"
            fill="#AD1619"
          />
          <path
            d="M2.96168 6.20007L3.12697 6.23427V6.48064C2.95092 6.62111 2.504 6.85786 2.504 6.85786V6.20007H2.96168Z"
            fill="#F1F9FF"
          />
          <path
            d="M8.15728 6.20007L7.99199 6.23427V6.48064C8.16804 6.62111 8.61496 6.85786 8.61496 6.85786V6.20007H8.15728Z"
            fill="#F1F9FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.38801 3.60301V3.52102C7.09997 3.3143 6.79833 3.21094 6.4831 3.21094C6.18088 3.0772 5.87499 3.02529 5.5654 3.0552C5.56549 3.05424 5.56553 3.05376 5.56553 3.05376C5.10004 3.00821 4.63093 3.21094 4.63093 3.21094C4.15807 3.21094 3.72601 3.52102 3.72601 3.52102V3.60301L4.29083 4.17028C4.29083 4.17028 4.44975 4.71608 5.56264 4.58802C5.56303 4.58889 5.56323 4.58934 5.56323 4.58934C5.56323 4.58934 6.30041 4.56922 6.3522 4.55199C6.37276 4.54515 6.39407 4.53893 6.41585 4.53257C6.56024 4.49042 6.72508 4.44229 6.82319 4.17028L7.38801 3.60301ZM5.56287 3.08453C5.56054 3.11204 5.55685 3.15684 5.55248 3.21411C5.55802 3.17307 5.56174 3.13001 5.56287 3.08453Z"
            fill="#AD1619"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.75989 3.69923L3.79826 3.65845L4.31111 4.14095C4.40846 4.11477 4.93687 3.98012 5.52711 3.97349V3.97324L5.54957 3.9733L5.57202 3.97324V3.97349C6.22597 3.98084 6.80402 4.14533 6.80402 4.14533C6.80402 4.14533 6.79783 4.19841 6.78278 4.26081C6.79871 4.22814 6.81758 4.19184 6.8394 4.15178L6.8448 4.14478L7.36172 3.65845L7.40009 3.69923L6.88644 4.18249C6.8115 4.3205 6.77376 4.4116 6.77376 4.44944C6.77376 4.50717 6.62357 4.54144 6.33044 4.57663C6.1008 4.6042 5.82978 4.62271 5.60809 4.62548V4.62584L5.57999 4.62574L5.55189 4.62584V4.62548C5.3302 4.62271 5.05918 4.6042 4.82954 4.57663C4.53641 4.54144 4.38622 4.50717 4.38622 4.44944C4.38622 4.44228 4.38487 4.43322 4.38217 4.42229C4.35261 4.38465 4.33183 4.32307 4.318 4.26752C4.30502 4.24154 4.2902 4.21318 4.27354 4.18249L3.75989 3.69923ZM6.62653 4.45054C6.66576 4.4689 6.69721 4.45058 6.72208 4.41542C6.71993 4.42513 6.71858 4.43391 6.71804 4.44178C6.71476 4.44393 6.70972 4.44651 6.70311 4.44929C6.68466 4.45705 6.65649 4.46531 6.61985 4.47367C6.54781 4.4901 6.44528 4.50644 6.32376 4.52103C6.08647 4.54952 5.80431 4.56827 5.57999 4.56974C5.35567 4.56827 5.07351 4.54952 4.83622 4.52103C4.7147 4.50644 4.61217 4.4901 4.54014 4.47367C4.50942 4.46666 4.48465 4.45972 4.46658 4.4531L4.47261 4.45054C4.59495 4.39329 5.40389 4.33958 5.54957 4.33031C5.69525 4.33958 6.50419 4.39329 6.62653 4.45054ZM6.7808 4.44028L6.77995 4.44126L6.78046 4.44055L6.7808 4.44028Z"
            fill="#C88A02"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.55612 2.67352C5.64891 2.67352 5.72412 2.59831 5.72412 2.50552C5.72412 2.41274 5.64891 2.33752 5.55612 2.33752C5.46334 2.33752 5.38812 2.41274 5.38812 2.50552C5.38812 2.59831 5.46334 2.67352 5.55612 2.67352Z"
            fill="#005BBF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.49343 2.03833H5.6101V2.11203H5.68633V2.2287H5.6101V2.46203H5.68633V2.5787H5.41602V2.46203H5.49343V2.2287H5.41602V2.11203H5.49343V2.03833Z"
            fill="#C88A02"
          />
          <rect
            x="5.47202"
            y="2.672"
            width="0.224"
            height="0.728"
            fill="#C88A02"
          />
          <path
            d="M3.85388 3.64843L3.54626 3.63686C3.6914 2.79807 4.40619 2.38708 5.5484 2.38708C6.69209 2.38708 7.40435 2.79985 7.53857 3.64176L7.12253 3.6854C7.05721 3.2757 6.37098 2.90493 5.55441 2.90493C4.73636 2.90493 3.92531 3.23561 3.85388 3.64843Z"
            fill="#C88A02"
          />
          <path
            opacity="0.3"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.73599 4.63208H7.37599V7.9025C7.37599 7.9025 7.1056 9.00008 5.55599 9.00008C4.00638 9.00008 3.73599 7.87356 3.73599 7.87356V4.63208Z"
            fill="#E1E5E8"
          />
          <mask
            id="mask3_5625_2317"
            maskUnits="userSpaceOnUse"
            x="3"
            y="4"
            width="5"
            height="6"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.73599 4.63208H7.37599V7.9025C7.37599 7.9025 7.1056 9.00008 5.55599 9.00008C4.00638 9.00008 3.73599 7.87356 3.73599 7.87356V4.63208Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask3_5625_2317)">
            <rect
              x="3.73599"
              y="6.64807"
              width="1.848"
              height="2.184"
              fill="#FFC034"
            />
            <rect
              x="3.73599"
              y="4.57605"
              width="1.848"
              height="2.128"
              fill="#AD1619"
            />
            <rect
              x="5.52798"
              y="6.59204"
              width="1.848"
              height="2.128"
              fill="#AD1619"
            />
            <rect
              x="5.52798"
              y="4.63208"
              width="1.96"
              height="2.072"
              fill="#F1F9FF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.74136 8.72141C6.74136 8.72141 5.55526 8.81466 5.55526 8.04968C5.55526 8.04968 5.54395 8.72141 4.30545 8.72141V9.32532H6.74136V8.72141Z"
              fill="#F1F9FF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.55599 7.09607C5.78795 7.09607 5.97599 6.8955 5.97599 6.64807C5.97599 6.40065 5.78795 6.20007 5.55599 6.20007C5.32403 6.20007 5.13599 6.40065 5.13599 6.64807C5.13599 6.8955 5.32403 7.09607 5.55599 7.09607Z"
              fill="#005BBF"
              stroke="#AD1619"
              strokeWidth="0.583333"
            />
          </g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.5 6C4.77614 6 5 5.77614 5 5.5C5 5.22386 4.77614 5 4.5 5C4.22386 5 4 5.22386 4 5.5C4 5.77614 4.22386 6 4.5 6Z"
            fill="#C88A02"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.5 6C6.77614 6 7 5.77614 7 5.5C7 5.22386 6.77614 5 6.5 5C6.22386 5 6 5.22386 6 5.5C6 5.77614 6.22386 6 6.5 6Z"
            fill="#C37C9C"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.5 8C6.77614 8 7 7.77614 7 7.5C7 7.22386 6.77614 7 6.5 7C6.22386 7 6 7.22386 6 7.5C6 7.77614 6.22386 8 6.5 8Z"
            fill="#FFC034"
          />
          <path
            d="M4.5 8C4.77614 8 5 7.77614 5 7.5C5 7.22386 4.77614 7 4.5 7C4.22386 7 4 7.22386 4 7.5C4 7.77614 4.22386 8 4.5 8Z"
            fill="#AD1619"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_5625_2317">
          <rect
            width="16"
            height="12"
            rx="1"
            fill="white"
          />
        </clipPath>
      </defs>
    </>
  ),
  de: (
    <>
      <g clipPath="url(#clip0_5625_2201)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 8H16V12H0V8Z"
          fill="#FFD018"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 4H16V8H0V4Z"
          fill="#E31D1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H16V4H0V0Z"
          fill="#272727"
        />
      </g>
      <defs>
        <clipPath id="clip0_5625_2201">
          <rect
            width="16"
            height="12"
            rx="1"
            fill="white"
          />
        </clipPath>
      </defs>
    </>
  ),
  pt: (
    <>
      <defs id="defs1" />
      <g
        id="layer1"
        transform="translate(1.3333333e-6,-0.176388)"
      >
        <g
          id="g1"
          transform="matrix(0.02666667,0,0,0.03,2.4350383e-6,0.176388)"
        >
          <rect
            width="600"
            height="400"
            fill="#ff0000"
            id="rect1"
            x="0"
            y="0"
          />
          <rect
            width="240"
            height="400"
            fill="#006600"
            id="rect2"
            x="0"
            y="0"
          />
          <g
            fill="#ffff00"
            fill-rule="evenodd"
            stroke="#000000"
            stroke-width="0.573"
            stroke-linecap="round"
            stroke-linejoin="round"
            id="g22"
          >
            <path
              d="M 318.24,262.04 C 288.03,261.13 149.5,174.66 148.55,160.89 l 7.6496,-12.757 c 13.741,19.966 155.36,104.06 169.27,101.08 l -7.2299,12.823"
              id="path2"
            />
            <path
              d="m 154.59,146.4 c -2.7101,7.2937 36.149,31.318 82.903,59.754 46.752,28.434 87.065,46.006 90.053,43.486 0.18256,-0.32544 1.4701,-2.5409 1.352,-2.5232 -0.56001,0.84402 -1.9234,1.1104 -4.0506,0.49741 -12.631,-3.6433 -45.575,-18.765 -86.374,-43.506 -40.798,-24.743 -76.294,-47.544 -81.811,-57.232 -0.38363,-0.67116 -0.65702,-1.8962 -0.60146,-2.8487 l -0.13405,-0.002 -1.1747,2.0532 -0.16139,0.32191 h -8.8e-4 z m 164.36,116.04 c -0.51238,0.92957 -1.4675,0.96044 -3.2816,0.76112 -11.3,-1.2506 -45.589,-17.925 -86.162,-42.213 -47.21,-28.26 -86.2,-54.01 -81.97,-60.74 l 1.1509,-2.0346 0.22665,0.0706 c -3.8037,11.405 76.948,57.578 81.702,60.522 46.724,28.947 86.115,45.851 89.601,41.458 l -1.2682,2.181 v -0.002 z"
              id="path3"
            />
            <path
              d="m 240.17,169.23 c 30.237,-0.23901 67.55,-4.1319 89.023,-12.69 l -4.6265,-7.5168 c -12.692,7.0247 -50.21,11.644 -84.652,12.335 -40.736,-0.37483 -69.49,-4.1681 -83.897,-13.835 l -4.3672,8.0045 c 26.484,11.207 53.623,13.587 88.52,13.703"
              id="path4"
            />
            <path
              d="m 330.44,156.71 c -0.73904,1.1818 -14.743,6.0113 -35.373,9.5753 -13.988,2.1325 -32.234,3.9555 -55.004,3.9776 -21.633,0.0203 -39.305,-1.5196 -52.684,-3.3329 -21.656,-3.3955 -32.833,-8.1201 -36.965,-9.7896 0.39509,-0.78581 0.64908,-1.337 1.0301,-2.0708 11.895,4.736 23.124,7.5918 36.279,9.6158 13.291,1.8 30.75,3.362 52.276,3.3417 22.664,-0.0229 40.709,-1.9844 54.616,-4.0534 21.155,-3.4122 32.711,-7.8034 34.334,-9.8425 l 1.494,2.5788 h -0.002 z m -4.0603,-7.6226 c -2.293,1.8415 -13.718,5.8932 -33.819,9.1034 -13.415,1.9226 -30.472,3.6433 -52.265,3.6645 -20.704,0.0203 -37.619,-1.375 -50.485,-3.2491 -20.414,-2.6661 -31.279,-7.4754 -35.196,-8.8776 0.3898,-0.67381 0.78666,-1.3423 1.1941,-2.0135 3.0479,1.5346 13.533,5.7909 34.226,8.7224 12.72,1.8036 29.661,3.1477 50.262,3.1265 21.69,-0.0221 38.553,-1.7762 51.883,-3.6883 20.205,-2.7799 31.077,-7.9472 32.728,-9.241 l 1.4728,2.4509 v 0.002 z"
              id="path5"
            />
            <path
              d="m 140.88,205.66 c 18.598,10.003 59.905,15.044 98.994,15.391 35.591,0.0564 81.958,-5.5016 99.297,-14.69 l -0.47712,-10.012 c -5.4246,8.4773 -55.113,16.609 -99.206,16.276 -44.093,-0.3325 -85.038,-7.1429 -98.687,-15.959 l 0.0794,8.9914"
              id="path6"
            />
            <path
              d="m 340.12,204.22 8.8e-4,2.3874 c -2.606,3.1159 -18.946,7.8255 -39.437,11.142 -15.595,2.391 -35.927,4.1945 -61.262,4.1945 -24.069,0 -43.263,-1.7163 -58.148,-4.0014 -23.529,-3.4264 -38.579,-9.4262 -41.6,-11.217 l 0.0132,-2.7852 c 9.0748,6.0334 33.661,10.447 41.917,11.798 14.788,2.2701 33.868,3.9732 57.817,3.9732 25.216,0 45.434,-1.7912 60.931,-4.1663 14.701,-2.1237 35.644,-7.6465 39.767,-11.324 h 8.8e-4 z m 0.01,-8.4922 8.8e-4,2.3874 c -2.606,3.1142 -18.946,7.8237 -39.437,11.14 -15.595,2.391 -35.927,4.1945 -61.262,4.1945 -24.069,0 -43.263,-1.7145 -58.148,-4.0014 -23.529,-3.4246 -38.579,-9.4245 -41.6,-11.216 l 0.0132,-2.7852 c 9.0748,6.0325 33.661,10.447 41.917,11.796 14.788,2.2719 33.868,3.9758 57.817,3.9758 25.216,0 45.434,-1.7921 60.931,-4.169 14.701,-2.1237 35.644,-7.6465 39.767,-11.324 l 8.8e-4,0.002 z"
              id="path7"
            />
            <path
              d="m 239.79,260.32 c -42.772,-0.25489 -79.421,-11.659 -87.16,-13.544 l 5.6433,8.8344 c 13.67,5.7503 49.424,14.32 81.927,13.371 32.504,-0.94809 60.91,-3.466 80.928,-13.211 l 5.7862,-9.1555 c -13.642,6.425 -60.068,13.639 -87.125,13.705"
              id="path8"
            />
            <path
              stroke-width="0.55"
              d="m 323.3,253.72 c -0.85016,1.2991 -1.7171,2.5823 -2.5963,3.8294 -9.4417,3.3293 -24.319,6.8245 -30.597,7.844 -12.824,2.6423 -32.665,4.594 -50.274,4.6029 -37.89,-0.55474 -68.905,-7.9719 -83.496,-14.299 l -1.1773,-2.0241 0.19225,-0.30427 1.9966,0.77435 c 25.948,9.2834 55.091,12.987 82.698,13.652 17.538,0.0617 35.095,-2.01 49.292,-4.5491 21.771,-4.3621 30.574,-7.65 33.275,-9.1405 l 0.68701,-0.38541 h -8.8e-4 z m 5.0172,-8.2753 c 0.022,0.0256 0.0441,0.0503 0.0653,0.0776 -0.63585,1.0733 -1.2911,2.1652 -1.9622,3.2623 -5.0357,1.8 -18.702,5.7988 -38.659,8.5893 -13.149,1.7912 -21.322,3.526 -47.479,4.034 -49.015,-1.2471 -80.75,-10.831 -88.289,-13.195 l -1.1174,-2.1431 c 28.406,7.4154 57.422,12.592 89.408,13.121 23.931,-0.50976 34.112,-2.2719 47.152,-4.0499 23.271,-3.6186 34.996,-7.4498 38.515,-8.5558 -0.0441,-0.0635 -0.0961,-0.13053 -0.15433,-0.19932 l 2.5231,-0.9428 -0.002,0.002 z"
              id="path9"
            />
            <path
              d="m 328.83,197.76 c 0.13873,28.137 -14.26,53.386 -25.858,64.525 -16.408,15.759 -38.163,25.896 -63.569,26.363 -28.37,0.52117 -55.12,-17.974 -62.295,-26.099 -14.028,-15.885 -25.449,-36.057 -25.815,-63.243 1.7376,-30.709 13.793,-52.1 31.268,-66.769 17.475,-14.669 40.743,-21.813 60.121,-21.302 22.358,0.59003 48.475,11.558 66.521,33.332 11.823,14.266 16.943,29.748 19.627,53.193 z m -89.186,-96.342 c 54.485,0 99.296,44.338 99.296,98.703 0,54.364 -44.811,98.704 -99.296,98.704 -54.485,0 -98.924,-44.339 -98.924,-98.704 0,-54.365 44.439,-98.703 98.924,-98.703"
              id="path10"
            />
            <path
              d="m 239.91,101.08 c 54.534,0 99.011,44.483 99.011,99.022 0,54.538 -44.478,99.02 -99.011,99.02 -54.534,0 -99.011,-44.481 -99.011,-99.02 0,-54.539 44.478,-99.022 99.011,-99.022 z m -96.832,99.0224 c 0,53.26 43.736,96.842 96.832,96.842 53.097,0 96.833,-43.582 96.833,-96.842 0,-53.262 -43.737,-96.844 -96.833,-96.844 -53.096,0 -96.832,43.584 -96.832,96.844 z"
              id="path11"
            />
            <path
              d="m 239.99,109.31 c 49.731,0 90.693,40.821 90.693,90.704 0,49.884 -40.963,90.703 -90.693,90.703 -49.73,0 -90.693,-40.819 -90.693,-90.703 0,-49.883 40.964,-90.704 90.693,-90.704 z m -88.515,90.7034 c 0,48.685 39.979,88.524 88.515,88.524 48.536,0 88.515,-39.839 88.515,-88.524 0,-48.686 -39.978,-88.525 -88.515,-88.525 -48.536,0 -88.515,39.839 -88.515,88.525 z"
              id="path12"
            />
            <path
              d="m 243.98,100.68 h -8.48545 l 0.01,198.96 h 8.51455 z"
              id="path13"
            />
            <path
              d="m 243.13,99.546 h 2.1598 l 0.0185,201.25 h -2.1616 l -0.0159,-201.25 z m -8.4213,0.0018 h 2.1766 l 0.003,201.25 H 234.71 v -201.25 z"
              id="path14"
            />
            <path
              d="m 338.99,203.935 v -7.3554 l -5.99,-5.58 -34,-9 -49,-5 -59,3 -42,10 -8.48,6.28 v 7.3572 l 21.48,-9.637 51,-8 h 49 l 36,4 25,6 z"
              id="path15"
            />
            <path
              d="m 239.95,184.77 c 23.383,-0.0432 46.07,2.2154 64.065,5.7194 18.569,3.7121 31.637,8.3556 36.105,13.571 l -0.005,2.5823 c -5.3884,-6.4902 -22.973,-11.248 -36.518,-13.968 -17.858,-3.474 -40.393,-5.7168 -63.647,-5.6736 -24.538,0.0459 -47.387,2.3698 -64.984,5.8032 -14.12,2.8019 -32.951,8.3679 -35.302,13.858 v -2.689 c 1.2911,-3.8003 15.313,-9.4792 34.984,-13.417 17.729,-3.4572 40.62,-5.7415 65.302,-5.7864 z m 0.01,-8.4922 c 23.383,-0.0423 46.07,2.2172 64.065,5.7194 18.569,3.7139 31.637,8.3556 36.105,13.571 l -0.005,2.5823 c -5.3884,-6.4885 -22.973,-11.247 -36.518,-13.966 -17.858,-3.4757 -40.393,-5.7185 -63.647,-5.6736 -24.538,0.0441 -47.276,2.3698 -64.875,5.8014 -13.626,2.5832 -33.226,8.3696 -35.412,13.86 v -2.6908 c 1.2911,-3.7588 15.597,-9.6414 34.985,-13.417 17.729,-3.4572 40.62,-5.7397 65.302,-5.7864 z"
              id="path16"
            />
            <path
              d="m 239.48,132.96 c 36.849,-0.18433 68.99,5.1523 83.695,12.685 l 5.3638,9.279 c -12.781,-6.888 -47.456,-14.05 -89.005,-12.979 -33.854,0.20814 -70.027,3.7271 -88.176,13.41 l 6.4035,-10.709 c 14.895,-7.7241 50.022,-11.643 81.72,-11.684"
              id="path17"
            />
            <path
              d="m 239.97,140.62 c 21.017,-0.0556 41.325,1.1298 57.476,4.0437 15.041,2.7993 29.385,7.0009 31.436,9.2604 l 1.5901,2.8099 c -4.9881,-3.257 -17.401,-6.8836 -33.339,-9.906 -16.006,-3.0083 -36.3,-4.0049 -57.2,-3.9502 -23.722,-0.0811 -42.152,1.1712 -57.969,3.9291 -16.728,3.13 -28.334,7.6015 -31.197,9.7261 l 1.5583,-2.9704 c 5.5631,-2.8381 14.39,-6.2592 29.223,-8.9297 16.357,-2.988 34.983,-3.8841 58.423,-4.0128 h -8.8e-4 z m -0.009,-8.4843 c 20.113,-0.0529 39.972,1.068 55.452,3.8506 12.209,2.3768 24.283,6.0872 28.704,9.3892 l 2.3256,3.6954 c -3.9536,-4.3947 -18.836,-8.5593 -31.974,-10.892 -15.361,-2.6494 -34.395,-3.698 -54.508,-3.8656 -21.108,0.0591 -40.615,1.352 -55.752,4.1081 -14.441,2.7481 -23.76,6.0016 -27.703,8.5425 l 2.0451,-3.0868 c 5.4414,-2.8646 14.232,-5.4954 25.303,-7.6465 15.249,-2.7764 34.876,-4.0358 56.108,-4.0949 z"
              id="path18"
            />
            <path
              d="m 289.15,241.26 c -18.218,-3.4008 -36.469,-3.8947 -49.217,-3.7447 -61.407,0.71967 -81.244,12.609 -83.665,16.209 l -4.5894,-7.4815 c 15.634,-11.332 49.073,-17.687 88.587,-17.037 20.518,0.33602 38.224,1.6986 53.119,4.5835 l -4.2358,7.4727"
              id="path19"
            />
            <path
              stroke-width="0.55"
              d="m 239.58,236.46 c 17.082,0.25488 33.849,0.96044 50.033,3.9784 l -1.172,2.069 c -15.031,-2.7746 -31.055,-3.8365 -48.803,-3.75 -22.663,-0.17727 -45.585,1.9394 -65.541,7.6668 -6.2968,1.7524 -16.721,5.8006 -17.784,9.1458 l -1.1659,-1.9226 c 0.33601,-1.9773 6.6363,-6.081 18.414,-9.3901 22.858,-6.5458 44.239,-7.6491 66.019,-7.799 v 0.002 z m 0.77519,-8.5963 c 17.698,0.33073 35.975,1.1492 53.74,4.6681 l -1.2206,2.1537 c -16.042,-3.1847 -31.369,-4.2466 -52.415,-4.5702 -22.735,0.0414 -46.851,1.6625 -68.778,8.0372 -7.0791,2.062 -19.297,6.5202 -19.704,10.05 l -1.1659,-2.0655 c 0.26545,-3.2059 10.842,-7.388 20.358,-10.156 22.096,-6.4241 46.275,-8.076 69.186,-8.1174 z"
              id="path20"
            />
            <path
              d="M 327.58,247.38 320.201,258.829 299,240 244,203 182,169 149.81,157.99 156.67,145.27 159,144 l 20,5 66,34 38,24 32,23 13,15 z"
              id="path21"
            />
            <path
              d="m 148.65,158.29 c 5.646,-3.8294 47.139,14.655 90.555,40.834 43.301,26.254 84.677,55.921 80.942,61.473 l -1.2285,1.9323 -0.56354,0.4445 c 0.12083,-0.0864 0.74345,-0.84755 -0.0609,-2.906 -1.8449,-6.0704 -31.195,-29.491 -79.894,-58.895 -47.475,-28.309 -87.041,-45.371 -90.997,-40.494 l 1.247,-2.3892 h -8.9e-4 z m 180.44,88.927 c 3.57,-7.052 -34.916,-36.044 -82.632,-64.272 -48.813,-27.666 -83.994,-43.951 -90.42,-39.095 l -1.4278,2.5991 c -0.0124,0.14287 0.052,-0.17727 0.35364,-0.4101 1.1685,-1.0195 3.1052,-0.95074 3.9792,-0.96662 11.065,0.16581 42.667,14.709 87.006,40.128 19.428,11.315 82.071,51.491 81.832,62.789 0.0168,0.97102 0.0803,1.1712 -0.28485,1.6519 l 1.5936,-2.4236 v -0.002 z"
              id="path22"
            />
          </g>
          <g id="g42">
            <path
              fill="#ffffff"
              stroke="#000000"
              stroke-width="0.67037"
              stroke-linejoin="bevel"
              d="m 180.6,211.01 c 0,16.271 6.6628,30.987 17.457,41.742 10.815,10.778 25.512,17.579 41.809,17.579 16.381,0 31.247,-6.6525 42.016,-17.389 10.769,-10.735 17.443,-25.552 17.446,-41.88 h -0.002 v -79.189 l -118.74,-0.14111 0.0123,79.278 h 0.002 z"
              id="path23"
            />
            <path
              fill="#ff0000"
              stroke="#000000"
              stroke-width="0.50734"
              d="m 182.82,211.12 v 0.045 c 0,15.557 6.4414,29.724 16.775,40.009 10.354,10.305 24.614,16.712 40.214,16.712 15.681,0 29.912,-6.3606 40.222,-16.626 10.308,-10.265 16.697,-24.433 16.699,-40.044 h -0.002 V 134.39 l -113.84,-0.0185 -0.0697,76.748 m 91.022,-53.747 0.004,48.891 -0.0414,5.1717 h 8.8e-4 c 0,1.3608 -0.082,2.9122 -0.24076,4.2333 -0.92512,7.7294 -4.4801,14.467 -9.7451,19.708 -6.1636,6.1357 -14.671,9.9413 -24.047,9.9413 -9.327,0 -17.639,-3.9379 -23.829,-10.1 -6.3497,-6.32 -10.03,-14.986 -10.03,-23.947 l -0.0132,-54.023 67.94,0.12259 0.002,0.002 z"
              id="path24"
            />
            <g id="castle3">
              <g
                id="castle"
                fill="#ffff00"
                stroke="#000000"
                stroke-width="0.5"
              >
                <path
                  stroke="none"
                  d="m 190.19,154.43 c 0.13493,-5.521 4.0524,-6.828 4.0806,-6.8474 0.0282,-0.0185 4.2314,1.4076 4.2173,6.8986 l -8.2978,-0.0512"
                  id="path25"
                />
                <path
                  d="m 186.81,147.69 -0.68172,6.3447 4.1406,0.009 c 0.0397,-5.2493 3.9739,-6.1225 4.0691,-6.1031 0.0891,-0.005 3.9889,1.1606 4.0929,6.1031 h 4.1511 l -0.74962,-6.3932 -15.022,0.0379 v 0.002 z"
                  id="path26"
                />
                <path
                  d="m 185.85,154.06 h 16.946 c 0.35717,0 0.64908,0.35277 0.64908,0.78404 0,0.43039 -0.29191,0.78141 -0.64908,0.78141 H 185.85 c -0.35717,0 -0.64908,-0.35102 -0.64908,-0.78141 0,-0.43127 0.29191,-0.78404 0.64908,-0.78404 z"
                  id="path27"
                />
                <path
                  d="m 192.01,154.03 c 0.0185,-3.3126 2.2621,-4.2501 2.2736,-4.2483 8.8e-4,0 2.3423,0.96661 2.3609,4.2483 h -4.6344"
                  id="path28"
                />
                <path
                  d="m 186.21,145.05 h 16.245 c 0.34218,0 0.62263,0.31839 0.62263,0.70468 0,0.38717 -0.28045,0.70467 -0.62263,0.70467 H 186.21 c -0.34218,0 -0.62263,-0.31573 -0.62263,-0.70467 0,-0.38629 0.28045,-0.70468 0.62263,-0.70468 z"
                  id="path29"
                />
                <path
                  d="m 186.55,146.47 h 15.538 c 0.32719,0 0.59529,0.31662 0.59529,0.70379 0,0.38805 -0.2681,0.70467 -0.59529,0.70467 H 186.55 c -0.32719,0 -0.59529,-0.31662 -0.59529,-0.70467 0,-0.38717 0.2681,-0.70379 0.59529,-0.70379 z"
                  id="path30"
                />
                <path
                  d="m 191.57,135.88 1.2267,0.002 v 0.87136 h 0.89513 v -0.89076 l 1.2567,0.004 v 0.88723 h 0.89778 v -0.89076 h 1.2576 l -0.002,2.0117 c 0,0.31574 -0.25398,0.52035 -0.54854,0.52035 h -4.4113 c -0.29633,0 -0.56972,-0.23724 -0.5706,-0.52652 l -0.003,-1.9879 h 8.8e-4 z"
                  id="path31"
                />
                <path
                  d="m 196.19,138.57 0.27691,6.4514 -4.3028,-0.0159 0.28486,-6.4523 3.741,0.0168"
                  id="path32"
                />
                <path
                  id="cp1"
                  d="m 190.94,141.56 0.13141,3.4775 -4.1256,0.002 0.11641,-3.4793 h 3.8786 -8.9e-4 z"
                />
                <path
                  id="use32"
                  d="m 201.549,141.56 0.13141,3.4775 -4.1256,0.002 0.11641,-3.4793 h 3.8786 -8.9e-4 z"
                />
                <path
                  id="cp2"
                  d="m 186.3,139.04 1.1994,0.003 v 0.87224 h 0.8775 v -0.89253 l 1.2294,0.004 v 0.889 h 0.87926 v -0.89253 l 1.2302,0.002 -0.002,2.0117 c 0,0.31398 -0.2487,0.51859 -0.5362,0.51859 h -4.3169 c -0.28926,0 -0.55824,-0.23548 -0.55913,-0.52564 l -0.003,-1.9888 h 8.8e-4 z"
                />
                <path
                  id="use33"
                  d="m 196.909,139.04 1.1994,0.003 v 0.87224 h 0.8775 v -0.89253 l 1.2294,0.004 v 0.889 h 0.87926 v -0.89253 l 1.2302,0.002 -0.002,2.0117 c 0,0.31398 -0.2487,0.51859 -0.5362,0.51859 h -4.3169 c -0.28926,0 -0.55824,-0.23548 -0.55913,-0.52564 l -0.003,-1.9888 h 8.8e-4 z"
                />
                <path
                  fill="#000000"
                  stroke="none"
                  d="m 193.9,140.61 c -0.0265,-0.62706 0.87661,-0.63411 0.86603,0 v 1.5364 h -0.866 v -1.536"
                  id="path33"
                />
                <path
                  id="cp3"
                  fill="#000000"
                  stroke="none"
                  d="m 188.57,142.84 c -0.003,-0.6059 0.83693,-0.61824 0.82635,0 v 1.1871 h -0.826 v -1.187"
                />
                <path
                  id="use34"
                  fill="#000000"
                  stroke="none"
                  d="m 199.211,142.84 c -0.003,-0.6059 0.83693,-0.61824 0.82635,0 v 1.1871 h -0.826 v -1.187"
                />
              </g>
              <g
                id="use35"
                fill="#ffff00"
                stroke="#000000"
                stroke-width="0.5"
                transform="translate(0,46.319801)"
              >
                <path
                  stroke="none"
                  d="m 190.19,154.43 c 0.13493,-5.521 4.0524,-6.828 4.0806,-6.8474 0.0282,-0.0185 4.2314,1.4076 4.2173,6.8986 l -8.2978,-0.0512"
                  id="path276"
                />
                <path
                  d="m 186.81,147.69 -0.68172,6.3447 4.1406,0.009 c 0.0397,-5.2493 3.9739,-6.1225 4.0691,-6.1031 0.0891,-0.005 3.9889,1.1606 4.0929,6.1031 h 4.1511 l -0.74962,-6.3932 -15.022,0.0379 v 0.002 z"
                  id="path277"
                />
                <path
                  d="m 185.85,154.06 h 16.946 c 0.35717,0 0.64908,0.35277 0.64908,0.78404 0,0.43039 -0.29191,0.78141 -0.64908,0.78141 H 185.85 c -0.35717,0 -0.64908,-0.35102 -0.64908,-0.78141 0,-0.43127 0.29191,-0.78404 0.64908,-0.78404 z"
                  id="path278"
                />
                <path
                  d="m 192.01,154.03 c 0.0185,-3.3126 2.2621,-4.2501 2.2736,-4.2483 8.8e-4,0 2.3423,0.96661 2.3609,4.2483 h -4.6344"
                  id="path279"
                />
                <path
                  d="m 186.21,145.05 h 16.245 c 0.34218,0 0.62263,0.31839 0.62263,0.70468 0,0.38717 -0.28045,0.70467 -0.62263,0.70467 H 186.21 c -0.34218,0 -0.62263,-0.31573 -0.62263,-0.70467 0,-0.38629 0.28045,-0.70468 0.62263,-0.70468 z"
                  id="path280"
                />
                <path
                  d="m 186.55,146.47 h 15.538 c 0.32719,0 0.59529,0.31662 0.59529,0.70379 0,0.38805 -0.2681,0.70467 -0.59529,0.70467 H 186.55 c -0.32719,0 -0.59529,-0.31662 -0.59529,-0.70467 0,-0.38717 0.2681,-0.70379 0.59529,-0.70379 z"
                  id="path281"
                />
                <path
                  d="m 191.57,135.88 1.2267,0.002 v 0.87136 h 0.89513 v -0.89076 l 1.2567,0.004 v 0.88723 h 0.89778 v -0.89076 h 1.2576 l -0.002,2.0117 c 0,0.31574 -0.25398,0.52035 -0.54854,0.52035 h -4.4113 c -0.29633,0 -0.56972,-0.23724 -0.5706,-0.52652 l -0.003,-1.9879 h 8.8e-4 z"
                  id="path282"
                />
                <path
                  d="m 196.19,138.57 0.27691,6.4514 -4.3028,-0.0159 0.28486,-6.4523 3.741,0.0168"
                  id="path283"
                />
                <path
                  id="path284"
                  d="m 190.94,141.56 0.13141,3.4775 -4.1256,0.002 0.11641,-3.4793 h 3.8786 -8.9e-4 z"
                />
                <path
                  id="path285"
                  d="m 201.549,141.56 0.13141,3.4775 -4.1256,0.002 0.11641,-3.4793 h 3.8786 -8.9e-4 z"
                />
                <path
                  id="path286"
                  d="m 186.3,139.04 1.1994,0.003 v 0.87224 h 0.8775 v -0.89253 l 1.2294,0.004 v 0.889 h 0.87926 v -0.89253 l 1.2302,0.002 -0.002,2.0117 c 0,0.31398 -0.2487,0.51859 -0.5362,0.51859 h -4.3169 c -0.28926,0 -0.55824,-0.23548 -0.55913,-0.52564 l -0.003,-1.9888 h 8.8e-4 z"
                />
                <path
                  id="path287"
                  d="m 196.909,139.04 1.1994,0.003 v 0.87224 h 0.8775 v -0.89253 l 1.2294,0.004 v 0.889 h 0.87926 v -0.89253 l 1.2302,0.002 -0.002,2.0117 c 0,0.31398 -0.2487,0.51859 -0.5362,0.51859 h -4.3169 c -0.28926,0 -0.55824,-0.23548 -0.55913,-0.52564 l -0.003,-1.9888 h 8.8e-4 z"
                />
                <path
                  fill="#000000"
                  stroke="none"
                  d="m 193.9,140.61 c -0.0265,-0.62706 0.87661,-0.63411 0.86603,0 v 1.5364 h -0.866 v -1.536"
                  id="path288"
                />
                <path
                  id="path289"
                  fill="#000000"
                  stroke="none"
                  d="m 188.57,142.84 c -0.003,-0.6059 0.83693,-0.61824 0.82635,0 v 1.1871 h -0.826 v -1.187"
                />
                <path
                  id="path290"
                  fill="#000000"
                  stroke="none"
                  d="m 199.211,142.84 c -0.003,-0.6059 0.83693,-0.61824 0.82635,0 v 1.1871 h -0.826 v -1.187"
                />
              </g>
              <g
                id="use36"
                fill="#ffff00"
                stroke="#000000"
                stroke-width="0.5"
                transform="rotate(-45.202042,312.76611,180.00356)"
              >
                <path
                  stroke="none"
                  d="m 190.19,154.43 c 0.13493,-5.521 4.0524,-6.828 4.0806,-6.8474 0.0282,-0.0185 4.2314,1.4076 4.2173,6.8986 l -8.2978,-0.0512"
                  id="path291"
                />
                <path
                  d="m 186.81,147.69 -0.68172,6.3447 4.1406,0.009 c 0.0397,-5.2493 3.9739,-6.1225 4.0691,-6.1031 0.0891,-0.005 3.9889,1.1606 4.0929,6.1031 h 4.1511 l -0.74962,-6.3932 -15.022,0.0379 v 0.002 z"
                  id="path292"
                />
                <path
                  d="m 185.85,154.06 h 16.946 c 0.35717,0 0.64908,0.35277 0.64908,0.78404 0,0.43039 -0.29191,0.78141 -0.64908,0.78141 H 185.85 c -0.35717,0 -0.64908,-0.35102 -0.64908,-0.78141 0,-0.43127 0.29191,-0.78404 0.64908,-0.78404 z"
                  id="path293"
                />
                <path
                  d="m 192.01,154.03 c 0.0185,-3.3126 2.2621,-4.2501 2.2736,-4.2483 8.8e-4,0 2.3423,0.96661 2.3609,4.2483 h -4.6344"
                  id="path294"
                />
                <path
                  d="m 186.21,145.05 h 16.245 c 0.34218,0 0.62263,0.31839 0.62263,0.70468 0,0.38717 -0.28045,0.70467 -0.62263,0.70467 H 186.21 c -0.34218,0 -0.62263,-0.31573 -0.62263,-0.70467 0,-0.38629 0.28045,-0.70468 0.62263,-0.70468 z"
                  id="path295"
                />
                <path
                  d="m 186.55,146.47 h 15.538 c 0.32719,0 0.59529,0.31662 0.59529,0.70379 0,0.38805 -0.2681,0.70467 -0.59529,0.70467 H 186.55 c -0.32719,0 -0.59529,-0.31662 -0.59529,-0.70467 0,-0.38717 0.2681,-0.70379 0.59529,-0.70379 z"
                  id="path296"
                />
                <path
                  d="m 191.57,135.88 1.2267,0.002 v 0.87136 h 0.89513 v -0.89076 l 1.2567,0.004 v 0.88723 h 0.89778 v -0.89076 h 1.2576 l -0.002,2.0117 c 0,0.31574 -0.25398,0.52035 -0.54854,0.52035 h -4.4113 c -0.29633,0 -0.56972,-0.23724 -0.5706,-0.52652 l -0.003,-1.9879 h 8.8e-4 z"
                  id="path297"
                />
                <path
                  d="m 196.19,138.57 0.27691,6.4514 -4.3028,-0.0159 0.28486,-6.4523 3.741,0.0168"
                  id="path298"
                />
                <path
                  id="path299"
                  d="m 190.94,141.56 0.13141,3.4775 -4.1256,0.002 0.11641,-3.4793 h 3.8786 -8.9e-4 z"
                />
                <path
                  id="path300"
                  d="m 201.549,141.56 0.13141,3.4775 -4.1256,0.002 0.11641,-3.4793 h 3.8786 -8.9e-4 z"
                />
                <path
                  id="path301"
                  d="m 186.3,139.04 1.1994,0.003 v 0.87224 h 0.8775 v -0.89253 l 1.2294,0.004 v 0.889 h 0.87926 v -0.89253 l 1.2302,0.002 -0.002,2.0117 c 0,0.31398 -0.2487,0.51859 -0.5362,0.51859 h -4.3169 c -0.28926,0 -0.55824,-0.23548 -0.55913,-0.52564 l -0.003,-1.9888 h 8.8e-4 z"
                />
                <path
                  id="path302"
                  d="m 196.909,139.04 1.1994,0.003 v 0.87224 h 0.8775 v -0.89253 l 1.2294,0.004 v 0.889 h 0.87926 v -0.89253 l 1.2302,0.002 -0.002,2.0117 c 0,0.31398 -0.2487,0.51859 -0.5362,0.51859 h -4.3169 c -0.28926,0 -0.55824,-0.23548 -0.55913,-0.52564 l -0.003,-1.9888 h 8.8e-4 z"
                />
                <path
                  fill="#000000"
                  stroke="none"
                  d="m 193.9,140.61 c -0.0265,-0.62706 0.87661,-0.63411 0.86603,0 v 1.5364 h -0.866 v -1.536"
                  id="path303"
                />
                <path
                  id="path304"
                  fill="#000000"
                  stroke="none"
                  d="m 188.57,142.84 c -0.003,-0.6059 0.83693,-0.61824 0.82635,0 v 1.1871 h -0.826 v -1.187"
                />
                <path
                  id="path305"
                  fill="#000000"
                  stroke="none"
                  d="m 199.211,142.84 c -0.003,-0.6059 0.83693,-0.61824 0.82635,0 v 1.1871 h -0.826 v -1.187"
                />
              </g>
            </g>
            <g
              id="use37"
              fill="#ffff00"
              stroke="#000000"
              stroke-width="0.5"
              transform="translate(45.713799)"
            >
              <path
                stroke="none"
                d="m 190.19,154.43 c 0.13493,-5.521 4.0524,-6.828 4.0806,-6.8474 0.0282,-0.0185 4.2314,1.4076 4.2173,6.8986 l -8.2978,-0.0512"
                id="path306"
              />
              <path
                d="m 186.81,147.69 -0.68172,6.3447 4.1406,0.009 c 0.0397,-5.2493 3.9739,-6.1225 4.0691,-6.1031 0.0891,-0.005 3.9889,1.1606 4.0929,6.1031 h 4.1511 l -0.74962,-6.3932 -15.022,0.0379 v 0.002 z"
                id="path307"
              />
              <path
                d="m 185.85,154.06 h 16.946 c 0.35717,0 0.64908,0.35277 0.64908,0.78404 0,0.43039 -0.29191,0.78141 -0.64908,0.78141 H 185.85 c -0.35717,0 -0.64908,-0.35102 -0.64908,-0.78141 0,-0.43127 0.29191,-0.78404 0.64908,-0.78404 z"
                id="path308"
              />
              <path
                d="m 192.01,154.03 c 0.0185,-3.3126 2.2621,-4.2501 2.2736,-4.2483 8.8e-4,0 2.3423,0.96661 2.3609,4.2483 h -4.6344"
                id="path309"
              />
              <path
                d="m 186.21,145.05 h 16.245 c 0.34218,0 0.62263,0.31839 0.62263,0.70468 0,0.38717 -0.28045,0.70467 -0.62263,0.70467 H 186.21 c -0.34218,0 -0.62263,-0.31573 -0.62263,-0.70467 0,-0.38629 0.28045,-0.70468 0.62263,-0.70468 z"
                id="path310"
              />
              <path
                d="m 186.55,146.47 h 15.538 c 0.32719,0 0.59529,0.31662 0.59529,0.70379 0,0.38805 -0.2681,0.70467 -0.59529,0.70467 H 186.55 c -0.32719,0 -0.59529,-0.31662 -0.59529,-0.70467 0,-0.38717 0.2681,-0.70379 0.59529,-0.70379 z"
                id="path311"
              />
              <path
                d="m 191.57,135.88 1.2267,0.002 v 0.87136 h 0.89513 v -0.89076 l 1.2567,0.004 v 0.88723 h 0.89778 v -0.89076 h 1.2576 l -0.002,2.0117 c 0,0.31574 -0.25398,0.52035 -0.54854,0.52035 h -4.4113 c -0.29633,0 -0.56972,-0.23724 -0.5706,-0.52652 l -0.003,-1.9879 h 8.8e-4 z"
                id="path312"
              />
              <path
                d="m 196.19,138.57 0.27691,6.4514 -4.3028,-0.0159 0.28486,-6.4523 3.741,0.0168"
                id="path313"
              />
              <path
                id="path314"
                d="m 190.94,141.56 0.13141,3.4775 -4.1256,0.002 0.11641,-3.4793 h 3.8786 -8.9e-4 z"
              />
              <path
                id="path315"
                d="m 201.549,141.56 0.13141,3.4775 -4.1256,0.002 0.11641,-3.4793 h 3.8786 -8.9e-4 z"
              />
              <path
                id="path316"
                d="m 186.3,139.04 1.1994,0.003 v 0.87224 h 0.8775 v -0.89253 l 1.2294,0.004 v 0.889 h 0.87926 v -0.89253 l 1.2302,0.002 -0.002,2.0117 c 0,0.31398 -0.2487,0.51859 -0.5362,0.51859 h -4.3169 c -0.28926,0 -0.55824,-0.23548 -0.55913,-0.52564 l -0.003,-1.9888 h 8.8e-4 z"
              />
              <path
                id="path317"
                d="m 196.909,139.04 1.1994,0.003 v 0.87224 h 0.8775 v -0.89253 l 1.2294,0.004 v 0.889 h 0.87926 v -0.89253 l 1.2302,0.002 -0.002,2.0117 c 0,0.31398 -0.2487,0.51859 -0.5362,0.51859 h -4.3169 c -0.28926,0 -0.55824,-0.23548 -0.55913,-0.52564 l -0.003,-1.9888 h 8.8e-4 z"
              />
              <path
                fill="#000000"
                stroke="none"
                d="m 193.9,140.61 c -0.0265,-0.62706 0.87661,-0.63411 0.86603,0 v 1.5364 h -0.866 v -1.536"
                id="path318"
              />
              <path
                id="path319"
                fill="#000000"
                stroke="none"
                d="m 188.57,142.84 c -0.003,-0.6059 0.83693,-0.61824 0.82635,0 v 1.1871 h -0.826 v -1.187"
              />
              <path
                id="path320"
                fill="#000000"
                stroke="none"
                d="m 199.211,142.84 c -0.003,-0.6059 0.83693,-0.61824 0.82635,0 v 1.1871 h -0.826 v -1.187"
              />
            </g>
            <g
              id="use38"
              transform="matrix(-1,0,0,1,479.79195,0)"
            >
              <g
                id="g335"
                fill="#ffff00"
                stroke="#000000"
                stroke-width="0.5"
              >
                <path
                  stroke="none"
                  d="m 190.19,154.43 c 0.13493,-5.521 4.0524,-6.828 4.0806,-6.8474 0.0282,-0.0185 4.2314,1.4076 4.2173,6.8986 l -8.2978,-0.0512"
                  id="path321"
                />
                <path
                  d="m 186.81,147.69 -0.68172,6.3447 4.1406,0.009 c 0.0397,-5.2493 3.9739,-6.1225 4.0691,-6.1031 0.0891,-0.005 3.9889,1.1606 4.0929,6.1031 h 4.1511 l -0.74962,-6.3932 -15.022,0.0379 v 0.002 z"
                  id="path322"
                />
                <path
                  d="m 185.85,154.06 h 16.946 c 0.35717,0 0.64908,0.35277 0.64908,0.78404 0,0.43039 -0.29191,0.78141 -0.64908,0.78141 H 185.85 c -0.35717,0 -0.64908,-0.35102 -0.64908,-0.78141 0,-0.43127 0.29191,-0.78404 0.64908,-0.78404 z"
                  id="path323"
                />
                <path
                  d="m 192.01,154.03 c 0.0185,-3.3126 2.2621,-4.2501 2.2736,-4.2483 8.8e-4,0 2.3423,0.96661 2.3609,4.2483 h -4.6344"
                  id="path324"
                />
                <path
                  d="m 186.21,145.05 h 16.245 c 0.34218,0 0.62263,0.31839 0.62263,0.70468 0,0.38717 -0.28045,0.70467 -0.62263,0.70467 H 186.21 c -0.34218,0 -0.62263,-0.31573 -0.62263,-0.70467 0,-0.38629 0.28045,-0.70468 0.62263,-0.70468 z"
                  id="path325"
                />
                <path
                  d="m 186.55,146.47 h 15.538 c 0.32719,0 0.59529,0.31662 0.59529,0.70379 0,0.38805 -0.2681,0.70467 -0.59529,0.70467 H 186.55 c -0.32719,0 -0.59529,-0.31662 -0.59529,-0.70467 0,-0.38717 0.2681,-0.70379 0.59529,-0.70379 z"
                  id="path326"
                />
                <path
                  d="m 191.57,135.88 1.2267,0.002 v 0.87136 h 0.89513 v -0.89076 l 1.2567,0.004 v 0.88723 h 0.89778 v -0.89076 h 1.2576 l -0.002,2.0117 c 0,0.31574 -0.25398,0.52035 -0.54854,0.52035 h -4.4113 c -0.29633,0 -0.56972,-0.23724 -0.5706,-0.52652 l -0.003,-1.9879 h 8.8e-4 z"
                  id="path327"
                />
                <path
                  d="m 196.19,138.57 0.27691,6.4514 -4.3028,-0.0159 0.28486,-6.4523 3.741,0.0168"
                  id="path328"
                />
                <path
                  id="path329"
                  d="m 190.94,141.56 0.13141,3.4775 -4.1256,0.002 0.11641,-3.4793 h 3.8786 -8.9e-4 z"
                />
                <path
                  id="path330"
                  d="m 201.549,141.56 0.13141,3.4775 -4.1256,0.002 0.11641,-3.4793 h 3.8786 -8.9e-4 z"
                />
                <path
                  id="path331"
                  d="m 186.3,139.04 1.1994,0.003 v 0.87224 h 0.8775 v -0.89253 l 1.2294,0.004 v 0.889 h 0.87926 v -0.89253 l 1.2302,0.002 -0.002,2.0117 c 0,0.31398 -0.2487,0.51859 -0.5362,0.51859 h -4.3169 c -0.28926,0 -0.55824,-0.23548 -0.55913,-0.52564 l -0.003,-1.9888 h 8.8e-4 z"
                />
                <path
                  id="path332"
                  d="m 196.909,139.04 1.1994,0.003 v 0.87224 h 0.8775 v -0.89253 l 1.2294,0.004 v 0.889 h 0.87926 v -0.89253 l 1.2302,0.002 -0.002,2.0117 c 0,0.31398 -0.2487,0.51859 -0.5362,0.51859 h -4.3169 c -0.28926,0 -0.55824,-0.23548 -0.55913,-0.52564 l -0.003,-1.9888 h 8.8e-4 z"
                />
                <path
                  fill="#000000"
                  stroke="none"
                  d="m 193.9,140.61 c -0.0265,-0.62706 0.87661,-0.63411 0.86603,0 v 1.5364 h -0.866 v -1.536"
                  id="path333"
                />
                <path
                  id="path334"
                  fill="#000000"
                  stroke="none"
                  d="m 188.57,142.84 c -0.003,-0.6059 0.83693,-0.61824 0.82635,0 v 1.1871 h -0.826 v -1.187"
                />
                <path
                  id="path335"
                  fill="#000000"
                  stroke="none"
                  d="m 199.211,142.84 c -0.003,-0.6059 0.83693,-0.61824 0.82635,0 v 1.1871 h -0.826 v -1.187"
                />
              </g>
              <g
                id="g350"
                fill="#ffff00"
                stroke="#000000"
                stroke-width="0.5"
                transform="translate(0,46.319801)"
              >
                <path
                  stroke="none"
                  d="m 190.19,154.43 c 0.13493,-5.521 4.0524,-6.828 4.0806,-6.8474 0.0282,-0.0185 4.2314,1.4076 4.2173,6.8986 l -8.2978,-0.0512"
                  id="path336"
                />
                <path
                  d="m 186.81,147.69 -0.68172,6.3447 4.1406,0.009 c 0.0397,-5.2493 3.9739,-6.1225 4.0691,-6.1031 0.0891,-0.005 3.9889,1.1606 4.0929,6.1031 h 4.1511 l -0.74962,-6.3932 -15.022,0.0379 v 0.002 z"
                  id="path337"
                />
                <path
                  d="m 185.85,154.06 h 16.946 c 0.35717,0 0.64908,0.35277 0.64908,0.78404 0,0.43039 -0.29191,0.78141 -0.64908,0.78141 H 185.85 c -0.35717,0 -0.64908,-0.35102 -0.64908,-0.78141 0,-0.43127 0.29191,-0.78404 0.64908,-0.78404 z"
                  id="path338"
                />
                <path
                  d="m 192.01,154.03 c 0.0185,-3.3126 2.2621,-4.2501 2.2736,-4.2483 8.8e-4,0 2.3423,0.96661 2.3609,4.2483 h -4.6344"
                  id="path339"
                />
                <path
                  d="m 186.21,145.05 h 16.245 c 0.34218,0 0.62263,0.31839 0.62263,0.70468 0,0.38717 -0.28045,0.70467 -0.62263,0.70467 H 186.21 c -0.34218,0 -0.62263,-0.31573 -0.62263,-0.70467 0,-0.38629 0.28045,-0.70468 0.62263,-0.70468 z"
                  id="path340"
                />
                <path
                  d="m 186.55,146.47 h 15.538 c 0.32719,0 0.59529,0.31662 0.59529,0.70379 0,0.38805 -0.2681,0.70467 -0.59529,0.70467 H 186.55 c -0.32719,0 -0.59529,-0.31662 -0.59529,-0.70467 0,-0.38717 0.2681,-0.70379 0.59529,-0.70379 z"
                  id="path341"
                />
                <path
                  d="m 191.57,135.88 1.2267,0.002 v 0.87136 h 0.89513 v -0.89076 l 1.2567,0.004 v 0.88723 h 0.89778 v -0.89076 h 1.2576 l -0.002,2.0117 c 0,0.31574 -0.25398,0.52035 -0.54854,0.52035 h -4.4113 c -0.29633,0 -0.56972,-0.23724 -0.5706,-0.52652 l -0.003,-1.9879 h 8.8e-4 z"
                  id="path342"
                />
                <path
                  d="m 196.19,138.57 0.27691,6.4514 -4.3028,-0.0159 0.28486,-6.4523 3.741,0.0168"
                  id="path343"
                />
                <path
                  id="path344"
                  d="m 190.94,141.56 0.13141,3.4775 -4.1256,0.002 0.11641,-3.4793 h 3.8786 -8.9e-4 z"
                />
                <path
                  id="path345"
                  d="m 201.549,141.56 0.13141,3.4775 -4.1256,0.002 0.11641,-3.4793 h 3.8786 -8.9e-4 z"
                />
                <path
                  id="path346"
                  d="m 186.3,139.04 1.1994,0.003 v 0.87224 h 0.8775 v -0.89253 l 1.2294,0.004 v 0.889 h 0.87926 v -0.89253 l 1.2302,0.002 -0.002,2.0117 c 0,0.31398 -0.2487,0.51859 -0.5362,0.51859 h -4.3169 c -0.28926,0 -0.55824,-0.23548 -0.55913,-0.52564 l -0.003,-1.9888 h 8.8e-4 z"
                />
                <path
                  id="path347"
                  d="m 196.909,139.04 1.1994,0.003 v 0.87224 h 0.8775 v -0.89253 l 1.2294,0.004 v 0.889 h 0.87926 v -0.89253 l 1.2302,0.002 -0.002,2.0117 c 0,0.31398 -0.2487,0.51859 -0.5362,0.51859 h -4.3169 c -0.28926,0 -0.55824,-0.23548 -0.55913,-0.52564 l -0.003,-1.9888 h 8.8e-4 z"
                />
                <path
                  fill="#000000"
                  stroke="none"
                  d="m 193.9,140.61 c -0.0265,-0.62706 0.87661,-0.63411 0.86603,0 v 1.5364 h -0.866 v -1.536"
                  id="path348"
                />
                <path
                  id="path349"
                  fill="#000000"
                  stroke="none"
                  d="m 188.57,142.84 c -0.003,-0.6059 0.83693,-0.61824 0.82635,0 v 1.1871 h -0.826 v -1.187"
                />
                <path
                  id="path350"
                  fill="#000000"
                  stroke="none"
                  d="m 199.211,142.84 c -0.003,-0.6059 0.83693,-0.61824 0.82635,0 v 1.1871 h -0.826 v -1.187"
                />
              </g>
              <g
                id="g365"
                fill="#ffff00"
                stroke="#000000"
                stroke-width="0.5"
                transform="rotate(-45.202042,312.76611,180.00356)"
              >
                <path
                  stroke="none"
                  d="m 190.19,154.43 c 0.13493,-5.521 4.0524,-6.828 4.0806,-6.8474 0.0282,-0.0185 4.2314,1.4076 4.2173,6.8986 l -8.2978,-0.0512"
                  id="path351"
                />
                <path
                  d="m 186.81,147.69 -0.68172,6.3447 4.1406,0.009 c 0.0397,-5.2493 3.9739,-6.1225 4.0691,-6.1031 0.0891,-0.005 3.9889,1.1606 4.0929,6.1031 h 4.1511 l -0.74962,-6.3932 -15.022,0.0379 v 0.002 z"
                  id="path352"
                />
                <path
                  d="m 185.85,154.06 h 16.946 c 0.35717,0 0.64908,0.35277 0.64908,0.78404 0,0.43039 -0.29191,0.78141 -0.64908,0.78141 H 185.85 c -0.35717,0 -0.64908,-0.35102 -0.64908,-0.78141 0,-0.43127 0.29191,-0.78404 0.64908,-0.78404 z"
                  id="path353"
                />
                <path
                  d="m 192.01,154.03 c 0.0185,-3.3126 2.2621,-4.2501 2.2736,-4.2483 8.8e-4,0 2.3423,0.96661 2.3609,4.2483 h -4.6344"
                  id="path354"
                />
                <path
                  d="m 186.21,145.05 h 16.245 c 0.34218,0 0.62263,0.31839 0.62263,0.70468 0,0.38717 -0.28045,0.70467 -0.62263,0.70467 H 186.21 c -0.34218,0 -0.62263,-0.31573 -0.62263,-0.70467 0,-0.38629 0.28045,-0.70468 0.62263,-0.70468 z"
                  id="path355"
                />
                <path
                  d="m 186.55,146.47 h 15.538 c 0.32719,0 0.59529,0.31662 0.59529,0.70379 0,0.38805 -0.2681,0.70467 -0.59529,0.70467 H 186.55 c -0.32719,0 -0.59529,-0.31662 -0.59529,-0.70467 0,-0.38717 0.2681,-0.70379 0.59529,-0.70379 z"
                  id="path356"
                />
                <path
                  d="m 191.57,135.88 1.2267,0.002 v 0.87136 h 0.89513 v -0.89076 l 1.2567,0.004 v 0.88723 h 0.89778 v -0.89076 h 1.2576 l -0.002,2.0117 c 0,0.31574 -0.25398,0.52035 -0.54854,0.52035 h -4.4113 c -0.29633,0 -0.56972,-0.23724 -0.5706,-0.52652 l -0.003,-1.9879 h 8.8e-4 z"
                  id="path357"
                />
                <path
                  d="m 196.19,138.57 0.27691,6.4514 -4.3028,-0.0159 0.28486,-6.4523 3.741,0.0168"
                  id="path358"
                />
                <path
                  id="path359"
                  d="m 190.94,141.56 0.13141,3.4775 -4.1256,0.002 0.11641,-3.4793 h 3.8786 -8.9e-4 z"
                />
                <path
                  id="path360"
                  d="m 201.549,141.56 0.13141,3.4775 -4.1256,0.002 0.11641,-3.4793 h 3.8786 -8.9e-4 z"
                />
                <path
                  id="path361"
                  d="m 186.3,139.04 1.1994,0.003 v 0.87224 h 0.8775 v -0.89253 l 1.2294,0.004 v 0.889 h 0.87926 v -0.89253 l 1.2302,0.002 -0.002,2.0117 c 0,0.31398 -0.2487,0.51859 -0.5362,0.51859 h -4.3169 c -0.28926,0 -0.55824,-0.23548 -0.55913,-0.52564 l -0.003,-1.9888 h 8.8e-4 z"
                />
                <path
                  id="path362"
                  d="m 196.909,139.04 1.1994,0.003 v 0.87224 h 0.8775 v -0.89253 l 1.2294,0.004 v 0.889 h 0.87926 v -0.89253 l 1.2302,0.002 -0.002,2.0117 c 0,0.31398 -0.2487,0.51859 -0.5362,0.51859 h -4.3169 c -0.28926,0 -0.55824,-0.23548 -0.55913,-0.52564 l -0.003,-1.9888 h 8.8e-4 z"
                />
                <path
                  fill="#000000"
                  stroke="none"
                  d="m 193.9,140.61 c -0.0265,-0.62706 0.87661,-0.63411 0.86603,0 v 1.5364 h -0.866 v -1.536"
                  id="path363"
                />
                <path
                  id="path364"
                  fill="#000000"
                  stroke="none"
                  d="m 188.57,142.84 c -0.003,-0.6059 0.83693,-0.61824 0.82635,0 v 1.1871 h -0.826 v -1.187"
                />
                <path
                  id="path365"
                  fill="#000000"
                  stroke="none"
                  d="m 199.211,142.84 c -0.003,-0.6059 0.83693,-0.61824 0.82635,0 v 1.1871 h -0.826 v -1.187"
                />
              </g>
            </g>
            <g id="quina">
              <path
                fill="#003399"
                d="m 232.636,202.406 v 0.005 c 0,2.2119 0.84927,4.2272 2.2118,5.6894 1.3652,1.4667 3.2454,2.3777 5.302,2.3777 2.0672,0 3.9439,-0.90487 5.3029,-2.3654 1.3581,-1.4587 2.2021,-3.47219 2.2021,-5.693 v -10.768 l -14.992,-0.0123 -0.0273,10.766"
                id="path38"
              />
              <path
                stroke="#ffffff"
                stroke-width="2.972"
                stroke-linecap="round"
                d="m 236.074,195.742 v 0 m 8.318,0 v 0 m -4.167,3.993 v 0 m -4.151,4.181 v 0 m 8.309,-0.011 v 0"
                id="path39"
              />
            </g>
            <g
              id="use39"
              transform="translate(0,-26.016001)"
            >
              <path
                fill="#003399"
                d="m 232.636,202.406 v 0.005 c 0,2.2119 0.84927,4.2272 2.2118,5.6894 1.3652,1.4667 3.2454,2.3777 5.302,2.3777 2.0672,0 3.9439,-0.90487 5.3029,-2.3654 1.3581,-1.4587 2.2021,-3.47219 2.2021,-5.693 v -10.768 l -14.992,-0.0123 -0.0273,10.766"
                id="path366"
              />
              <path
                stroke="#ffffff"
                stroke-width="2.972"
                stroke-linecap="round"
                d="m 236.074,195.742 v 0 m 8.318,0 v 0 m -4.167,3.993 v 0 m -4.151,4.181 v 0 m 8.309,-0.011 v 0"
                id="path367"
              />
            </g>
            <g
              id="use40"
              transform="translate(-20.799)"
            >
              <path
                fill="#003399"
                d="m 232.636,202.406 v 0.005 c 0,2.2119 0.84927,4.2272 2.2118,5.6894 1.3652,1.4667 3.2454,2.3777 5.302,2.3777 2.0672,0 3.9439,-0.90487 5.3029,-2.3654 1.3581,-1.4587 2.2021,-3.47219 2.2021,-5.693 v -10.768 l -14.992,-0.0123 -0.0273,10.766"
                id="path368"
              />
              <path
                stroke="#ffffff"
                stroke-width="2.972"
                stroke-linecap="round"
                d="m 236.074,195.742 v 0 m 8.318,0 v 0 m -4.167,3.993 v 0 m -4.151,4.181 v 0 m 8.309,-0.011 v 0"
                id="path369"
              />
            </g>
            <g
              id="use41"
              transform="translate(20.745001)"
            >
              <path
                fill="#003399"
                d="m 232.636,202.406 v 0.005 c 0,2.2119 0.84927,4.2272 2.2118,5.6894 1.3652,1.4667 3.2454,2.3777 5.302,2.3777 2.0672,0 3.9439,-0.90487 5.3029,-2.3654 1.3581,-1.4587 2.2021,-3.47219 2.2021,-5.693 v -10.768 l -14.992,-0.0123 -0.0273,10.766"
                id="path370"
              />
              <path
                stroke="#ffffff"
                stroke-width="2.972"
                stroke-linecap="round"
                d="m 236.074,195.742 v 0 m 8.318,0 v 0 m -4.167,3.993 v 0 m -4.151,4.181 v 0 m 8.309,-0.011 v 0"
                id="path371"
              />
            </g>
            <g
              id="use42"
              transform="translate(0,25.784)"
            >
              <path
                fill="#003399"
                d="m 232.636,202.406 v 0.005 c 0,2.2119 0.84927,4.2272 2.2118,5.6894 1.3652,1.4667 3.2454,2.3777 5.302,2.3777 2.0672,0 3.9439,-0.90487 5.3029,-2.3654 1.3581,-1.4587 2.2021,-3.47219 2.2021,-5.693 v -10.768 l -14.992,-0.0123 -0.0273,10.766"
                id="path372"
              />
              <path
                stroke="#ffffff"
                stroke-width="2.972"
                stroke-linecap="round"
                d="m 236.074,195.742 v 0 m 8.318,0 v 0 m -4.167,3.993 v 0 m -4.151,4.181 v 0 m 8.309,-0.011 v 0"
                id="path373"
              />
            </g>
          </g>
        </g>
      </g>
    </>
  ),
  it: (
    <>
      <defs id="defs1" />
      <g id="layer1">
        <g
          id="g1"
          transform="scale(5.3333333,6)"
        >
          <rect
            width="3"
            height="2"
            fill="#009246"
            id="rect1"
            x="0"
            y="0"
          />
          <rect
            width="2"
            height="2"
            x="1"
            fill="#ffffff"
            id="rect2"
            y="0"
          />
          <rect
            width="1"
            height="2"
            x="2"
            fill="#ce2b37"
            id="rect3"
            y="0"
          />
        </g>
      </g>
    </>
  ),
})
